import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { ServiceProCookieConsentDialogComponent } from "./service-pro-cookie-consent-dialog.component";

@Injectable({ providedIn: "root" })
export class ServiceProCookieConsentDialog {
    constructor(private readonly dialog: MatDialog) {}

    public open(): void {
        this.dialog.open(ServiceProCookieConsentDialogComponent, { disableClose: true, maxWidth: "500px" });
    }
}
